import React from 'react'
import posed from 'react-pose'

const PosedLink = posed.div({
  start: { opacity: 0, y: '20px' },
  end: {
    opacity: 1,
    y: '0px',
    delay: 1500,
    transition: {
      duration: 500,
    },
  },
})

const SectionHeader = ({ children }) => {
  return (
    <PosedLink initialPose="start" pose="end">
      <h2 className="text-xl font-semibold py-5 z-10">{children}</h2>
    </PosedLink>
  )
}

export default SectionHeader
